<template>
  <section>
    <filter-data
      v-if="filterData"
      v-model="filter"
      @date-ready="$emit('filter-date')"
    />
    <b-table
      v-if="data"
      :data="data"
      :loading="isLoading"
      :checkable="!isntCheckable"
      :is-row-checkable="(row) => row.Situacao === 'Disponível'"
      :checked-rows.sync="checkedRows"
      class="tableList"
      :paginated="isPaginated"
      :current-page.sync="currentPage"
      :per-page="perPage"
      :pagination-simple="isPaginationSimple"
      :pagination-position="paginationPosition"
      aria-page-label="Page"
      aria-current-label="Current page"
    >
      <!-- eslint-disable-next-line -->
      <template slot-scope="columns">
        <b-table-column
          field="date"
          label="Data"
        >
          {{ columns.row.Data }}
        </b-table-column>
        <b-table-column
          v-if="columns.row.time"
          field="time"
          label="Horário"
        >
          {{ columns.row.time }}
        </b-table-column>
        <b-table-column
          field="description"
          label="Descrição"
        >
          <span v-if="columns.row.Finalidade">
            {{ columns.row.Finalidade.Descricao }}
          </span>
        </b-table-column>
        <b-table-column
          v-if="columns.row.note"
          field="note"
          label="Observação"
          class="note"
        >
          <span
            @click="togglePreparationModal()"
            class="view"
          >{{
            $t('agenda.preparo')
          }}</span>
          <i class="icon-ic_alert-blue" />
        </b-table-column>
        <b-table-column
          v-if="columns.row.unit"
          field="unit"
          label="Unidade"
        >
          {{ columns.row.unit }}
        </b-table-column>
        <b-table-column
          field="action"
          label=""
        >
          <router-link
            v-if="columns.row.Situacao === 'Aguardando'"
            to="#"
            class="actions"
          >
            <span class="view waiting">{{ $t('botoes.aguardando') }}</span>
          </router-link>
          <div
            v-else-if="columns.row.Situacao === 'Disponível'"
            class="actions"
          >
            <span
              @click="
                openDocs(
                  columns.row.Codigo,
                  columns.row.DataSolicitacaoRelatorio,
                  columns.row.Prontuario
                )
              "
              class="view view-desktop"
            >
              {{ $t('botoes.visualizar') }}
              <i class="icon-ic_link" />
            </span>
            <div
              @click="
                openDocs(
                  columns.row.Codigo,
                  columns.row.DataSolicitacaoRelatorio,
                  columns.row.Prontuario
                )
              "
              class="view view-mobile"
            >
              {{ $t('botoes.baixar-arquivo') }}
              <i class="icon-ic_download" />
              <br />
              <span class="view view-mobile informacao">
                {{ $t('documentos.aviso-download') }}
              </span>
            </div>
          </div>
          <router-link
            v-else-if="columns.row.Situacao === 'Indisponível'"
            to="#"
            class="actions"
          >
            <span
              @click="toggleUnavailableExam(columns.row.Finalidade.Descricao)"
              class="unavailable"
            >
              {{ $t('botoes.indisponivel') }}
              <i class="icon-ic_alert-red" />
            </span>
          </router-link>
        </b-table-column>
      </template>
    </b-table>

    <div
      v-if="!data"
      class="container no-data"
    >
      <div class="img-container">
        <img
          src="~@/assets/images/banners/doctors_calendar.svg"
          alt="Doutores"
        />
      </div>
      <h1 class="title">
        {{ $t('documentos.sem-dados.titulo') }}
      </h1>
      <h2 class="subtitle">
        {{ $t('documentos.sem-dados.subtitulo') }}
      </h2>
    </div>
    <unavailable-exam
      :toggle="unavailableExam"
      @closeModal="toggleUnavailableExam()"
      :procedure="procedure"
    />
  </section>
</template>
<script>
import FilterData from '@/components/shared/filter/FilterData'
import UnavailableExam from '@/components/shared/modal/UnavailableExam'
import { mapGetters, mapActions } from 'vuex'
import { WindowOpener } from '../../../helpers/window.helper'

export default {
  name: 'TableList',
  components: {
    FilterData,
    UnavailableExam
  },
  data () {
    return {
      unavailableExam: false,
      absenceModal: false,
      preparationModal: false,
      filter: {
        pagina: 0,
        tamanho: 8
      },
      checkedRows: [],
      procedure: null,
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: 'bottom',
      currentPage: 1,
      perPage: 10
    }
  },
  props: {
    data: {
      type: [Array, String],
      default: () => {
        return []
      }
    },
    columns: {
      type: Array,
      required: true
    },
    isntCheckable: {
      type: Boolean
    },
    filterData: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'isLoading',
      getPatientPrintDocs: 'getPatientPrintDocs'
    }),
    checkedRowsProp () {
      const checkedItems = Object.assign(
        {},
        ...this.checkedRows.map((e) => {
          const payload = {
            [e.DataSolicitacaoRelatorio]: e.Codigo
          }
          return payload
        })
      )
      return checkedItems
    }
  },
  methods: {
    ...mapActions(['obterDocumento', 'setPatientAllPrintTests']),
    toggleUnavailableExam (value) {
      this.procedure = value
      this.unavailableExam = !this.unavailableExam
    },
    toggleAbsenceModal () {
      this.absenceModal = !this.absenceModal
    },
    togglePreparationModal () {
      this.preparationModal = !this.preparationModal
    },
    async openAllDocs () {
      await this.setPatientAllPrintTests(this.checkedRowsProp)
        .then(() => {
          const file = new Blob([this.getPatientPrintDocs], {
            type: 'application/pdf'
          })
          const fileURL = URL.createObjectURL(file)
          window.open(fileURL)
        })
        .catch((err) => {
          throw err
        })
    },
    async openDocs (id, date, prontuario) {
      const payload = {
        id,
        date,
        prontuario
      }
      let newWin = new WindowOpener(window, navigator)
      await this.obterDocumento({ ...payload })
        .then(() => {
          const file = new Blob([this.getPatientPrintDocs], {
            type: 'application/pdf'
          })
          const fileURL = URL.createObjectURL(file)
          newWin.open(fileURL)
        })
        .catch((err) => {
          throw err
        })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~@/assets/stylesheets/base";
@import "~@/assets/stylesheets/listpagination";
@import "~@/assets/stylesheets/table";

.informacao {
  font-size: small;
}

@media (max-width: 64rem) {
  .actions {
    text-align: center;
  }
}
</style>
